import { ModalWrapper, TipWrapper } from './atom'

export function TipsModal({ tips }: { tips: string }) {
  return (
    <ModalWrapper>
      <TipWrapper>{tips}</TipWrapper>
    </ModalWrapper>
  )
}
